import {EUR, USD} from '~/entities/currencies';
import {invariant} from '~/library/toolbox';
import {BaseCurrencyCode} from '~/library/types';
import {selectFinancesData} from '~/redux/finances/financesPrimitives';
import {useAppSelector} from '~/shared/store';

export function useCardSettings(currency: BaseCurrencyCode) {
    const settings = useAppSelector(state => selectFinancesData(state)?.operationsSettings);

    invariant(!!settings, 'Financse data are not loaded yet');

    const cardSettings = {
        [USD]: {
            minimal: settings.usd_top_up_card_minimal,
            feeRelative: settings.usd_top_up_card_fee_relative,
            feeAbsolute: settings.usd_top_up_card_fee_absolute,
            maximalPerOperationTotal: settings.usd_top_up_card_maximal_per_operation,
            maximalPerDayTotal: settings.usd_top_up_card_maximal_per_day_total,
            maximalPerDayCurrent: settings.usd_top_up_card_maximal_per_day_current,
            maximalPerMonthTotal: settings.usd_top_up_card_maximal_per_month_total,
            maximalPerMonthCurrent: settings.usd_top_up_card_maximal_per_month_current,
        },
        [EUR]: {
            minimal: settings.eur_top_up_card_minimal,
            feeRelative: settings.eur_top_up_card_fee_relative,
            feeAbsolute: settings.eur_top_up_card_fee_absolute,
            maximalPerOperationTotal: settings.eur_top_up_card_maximal_per_operation,
            maximalPerDayTotal: settings.eur_top_up_card_maximal_per_day_total,
            maximalPerDayCurrent: settings.eur_top_up_card_maximal_per_day_current,
            maximalPerMonthTotal: settings.eur_top_up_card_maximal_per_month_total,
            maximalPerMonthCurrent: settings.eur_top_up_card_maximal_per_month_current,
        },
    };

    return cardSettings[currency];
}
